<template>
  <v-app>
    <topbar v-if="$route.name !== 'Login'"/>
    <sidebar v-if="$route.name !== 'Login'"/>
    <v-main>
      <specialDay v-if="$route.name !== 'Login'" ></specialDay>
      <v-container v-if="$route.name !== 'Login'" fluid>
        <transition
          mode="out-in"
          :enter-active-class="transitionIn"
          :leave-active-class="transitionOut">
            <router-view/>
        </transition>
      </v-container>

      <v-container v-else fluid fill-height class="login">
          <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import sidebar from '@/components/_SideBar'
import topbar from '@/components/_TopBar'
import specialDay from '@/components/SpecialDay'

export default {
  name: 'App',
  components: {
    sidebar,
    topbar,
    specialDay

  },
  data() {
    return {
      transitionIn: 'animate__animated animate__fadeIn',
      transitionOut: 'animate__animated animate__fadeOut'
    }
  },
  watch: {
    '$route'(to) {
      window.addEventListener('focus', () => {
        document.title = to.meta.title || 'Grupo C&B Propiedades'
      })
      window.addEventListener('blur', () => {
        document.title = 'Vuelve, te extrañamos!'
      })
    },
  },
  computed: {

  },
  methods: {
  },
  created() {
  },
  mounted() {},
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style scoped>
.fullscreen {
  width: 100%;
  height: 100vh;
}

</style>
